"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createImmutableMimeBundle = exports.createImmutableOutput = exports.appendCellToNotebook = exports.appendCell = exports.removeCell = exports.insertCellAfter = exports.insertCellAt = exports.stringifyNotebook = exports.parseNotebook = exports.createCodeCell = exports.fromJS = exports.toJS = exports.monocellNotebook = exports.emptyNotebook = exports.emptyMarkdownCell = exports.emptyCodeCell = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _immutable = require("immutable");

var Immutable = _interopRequireWildcard(_immutable);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var v4 = require("./v4");
var v3 = require("./v3");

var _require = require("./structures"),
    emptyNotebook = _require.emptyNotebook,
    emptyCodeCell = _require.emptyCodeCell,
    emptyMarkdownCell = _require.emptyMarkdownCell,
    appendCell = _require.appendCell,
    monocellNotebook = _require.monocellNotebook,
    createCodeCell = _require.createCodeCell,
    appendCellToNotebook = _require.appendCellToNotebook,
    insertCellAt = _require.insertCellAt,
    insertCellAfter = _require.insertCellAfter,
    removeCell = _require.removeCell;

function freezeReviver(k, v) {
  return Object.freeze(v);
}

// Expected usage of below is
// fromJS(parseNotebook(string|buffer))

function parseNotebook(notebookString) {
  return JSON.parse(notebookString, freezeReviver);
}

function fromJS(notebook) {
  if (Immutable.Map.isMap(notebook)) {
    // $FlowFixMe: isMap doesn't hint to flow that this is an Immutable
    var immNotebook = notebook;
    if (immNotebook.has("cellOrder") && immNotebook.has("cellMap")) {
      return immNotebook;
    }
    throw new TypeError("commutable was passed an Immutable.Map structure that is not a notebook");
  }

  // $FlowFixMe: isMap doesn't hint to flow that this is a plain Object
  var notebookJSON = notebook;

  if (notebookJSON.nbformat === 4 && notebookJSON.nbformat_minor >= 0) {
    if (Array.isArray(notebookJSON.cells) && _typeof(notebookJSON.metadata) === "object") {
      return v4.fromJS(notebookJSON);
    }
  } else if (notebookJSON.nbformat === 3 && notebookJSON.nbformat_minor >= 0) {
    return v3.fromJS(notebookJSON);
  }

  if (notebookJSON.nbformat) {
    throw new TypeError("nbformat v" + notebookJSON.nbformat + "." + notebookJSON.nbformat_minor + " not recognized");
  }

  throw new TypeError("This notebook format is not supported");
}

function toJS(immnb) {
  var minorVersion = immnb.get("nbformat_minor", null);

  if (immnb.get("nbformat") === 4 && typeof minorVersion === "number" && minorVersion >= 0) {
    return v4.toJS(immnb);
  }
  throw new TypeError("Only notebook formats 3 and 4 are supported!");
}

// Expected usage is stringifyNotebook(toJS(immutableNotebook))
function stringifyNotebook(notebook) {
  return JSON.stringify(notebook, null, 2);
}

var createImmutableOutput = v4.createImmutableOutput;
var createImmutableMimeBundle = v4.createImmutableMimeBundle;

exports.emptyCodeCell = emptyCodeCell;
exports.emptyMarkdownCell = emptyMarkdownCell;
exports.emptyNotebook = emptyNotebook;
exports.monocellNotebook = monocellNotebook;
exports.toJS = toJS;
exports.fromJS = fromJS;
exports.createCodeCell = createCodeCell;
exports.parseNotebook = parseNotebook;
exports.stringifyNotebook = stringifyNotebook;
exports.insertCellAt = insertCellAt;
exports.insertCellAfter = insertCellAfter;
exports.removeCell = removeCell;
exports.appendCell = appendCell;
exports.appendCellToNotebook = appendCellToNotebook;
exports.createImmutableOutput = createImmutableOutput;
exports.createImmutableMimeBundle = createImmutableMimeBundle;


//////////////////
// WEBPACK FOOTER
// ./~/@nteract/commutable/lib/index.js
// module id = 193
// module chunks = 186292428941015